import React from "react";

export const Logo = () => {
  return (
    <a href="/"> <img width={172} src="imgs/decision-ai-logo.svg" alt="logo" /></a>
  )
}
